module.exports = __webpack_public_path__ + "static/img/itemBtnBg1.15f68a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/itemBtnBg1.png
// module id = gtZG
// module chunks = 0